// removed by extract-text-webpack-plugin
module.exports = {"calendar-checkbox":"calendar-checkbox","selected":"selected","calendar-checkbox-state":"calendar-checkbox-state","calendar-checkbox-name":"calendar-checkbox-name"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/calendar-checkbox/calendar-checkbox.style.sass
// module id = mrfP
// module chunks = 0